/**
* 系统管理  角色管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" ref="formInlineRef" class="user-search">
      <el-form-item label="权限名称：" prop="roleName">
        <el-input size="small" v-model="formInline.roleName" placeholder="请输入权限名称"></el-input>
      </el-form-item>
      <el-form-item label="权限描述：" prop="remark">
        <el-input size="small" v-model="formInline.remark" placeholder="请输入权限描述"></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-select size="small" v-model="formInline.status" clearable placeholder="请选择">
          <el-option v-for="(type,index) in statusInfo" :label="type" :value="index" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：" prop="datePicker">
        <el-date-picker style="height: 33px;width: 300px;"
                        v-model="times"
                        type="daterange"
                        @change="dataPicker"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="tableList">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
              :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column  prop="roleName"  align="center"  label="权限名称">
      </el-table-column>
      <el-table-column  prop="remark" label="权限描述"  align="center" >
      </el-table-column>
      <el-table-column  prop="createTime" label="创建时间"  align="center" >
        <template slot-scope="scope">
          <div>{{scope.row.createTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center"  prop="status" label="使用状态" width="170px">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-text="使用中"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0"
            @change="turn(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="300px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" >编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteData(scope.$index, scope.row)" v-if="scope.row.status==0">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="权限名称" prop="roleName">
          <el-input size="small" v-model="editForm.roleName" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="权限描述" prop="remark">
          <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色权限配置" prop="roleNo">
          <el-tree
            ref="addtree"
            :data="data"
            show-checkbox
            node-key="id"
            :default-checked-keys="checkmenu"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" :disabled="isDisabled" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 菜单权限 -->
    <el-dialog title="菜单权限" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-tree ref="tree" :default-expand-all="false" :data="RoleRight" :props="RoleRightProps" :default-checked-keys="checkmenu" node-key="id" show-checkbox>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { qryMenuByRole } from '../../api/userMG'
import {
  qrySysRoleList,addSysRole,upSysRole,delSysRole,upSysRoleMenu
} from '../../api/sysApi'
import Pagination from '../../components/Pagination'
import {timestampToTime,parseTime} from "../../utils/util";
export default {
  data() {
    return {
      isDisabled: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      statusInfo:{'':'全部',0:'已禁用', 1:'使用中'},
      title: '添加',
      data: [],
      times:'',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      editForm: {
        id: '',
        systemNo: '',
        roleNo: '',
        roleName: '',
        remark:'',
        status:''
        //token: localStorage.getItem('logintoken')
      },
      // rules 表单验证
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '请输入权限描述', trigger: 'blur' },
        ]
      },
      formInline: {
        beginTime: "", // 开始时间
        endTime: "" ,// 结束时间
        page: 1,
        pageSize: 10,
        remark: '',
        //varName: '',
        roleName: '',
        status:'',
        //token: localStorage.getItem('logintoken')
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.tableList(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    /**
     * @name: dataPicker
     * @Author: TJH
     * @msg: 时间选择器
     * @Date: 2021-02-25 14:47:12
     * @param value：[开始时间,结束时间]
     * @return {*}
     */
    dataPicker(value) {
      if (value != null) {
        console.log(value);
        this.formInline.beginTime = parseTime(
          value[0],
          "{y}-{m}-{d}"
        );
        this.formInline.endTime = parseTime(value[1], "{y}-{m}-{d}");
      } else {
        this.formInline.beginTime = "";
        this.formInline.endTime = "";
      }
    },
    // 获取角色列表
    tableList(parameter) {
      this.loading = true;
      qrySysRoleList(parameter)
        .then(res => {
          this.loading = false
          if (res.code!=1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.list;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.data.total;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统异常，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.tableList(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.remark = row.remark
        this.editForm.roleName = row.roleName
        this.editForm.systemNo = row.systemNo
        this.editForm.roleNo = row.roleNo
        this.editForm.status=row.status+''
      } else {
        this.title = '添加'
        this.editForm.remark = ''
        this.editForm.roleName = ''
        this.editForm.systemNo = ''
        this.checkmenu = ''
        this.editForm.status='0'
      }
      qryMenuByRole({})
        .then(res => {
          if (res.code==1) {
            this.data = this.changeArr(res.data)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })

      if(row!=undefined){
        qryMenuByRole({roleId:row.id==null?'':row.id})
          .then(res => {
            if (res.code==1) {
              this.changemenu(res.data)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          let parentArr = this.$refs.addtree.getHalfCheckedKeys();
          //获取子节点未全选时的父节点id
          let childArr = this.$refs.addtree.getCheckedKeys();
          //获取所有选中节点的id

          let list= parentArr.concat(childArr);
          if (list.length != 0) {
            for (let i = 0; i < list.length; i++) {
              list[i]={
                menuId:list[i],
                roleId:this.editForm.id
              }
            }
          }

          let parm = {
            roleName: this.editForm.roleName,
            id: this.editForm.id,
            remark:this.editForm.remark,
            list:list
          }


          if(this.editForm.id){
            upSysRoleMenu(parm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code==1) {
                  this.$message({
                    type: 'success',
                    message: '权限保存成功'
                  })
                  this.menuAccessshow = false
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.loading = false
                this.$message.error('权限保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }else{
            addSysRole(parm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code==1) {
                  this.$message({
                    type: 'success',
                    message: '角色保存成功！'
                  })
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('角色保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }

        } else {
          this.isDisabled = false;
          return false
        }
      })
    },
    deleteData(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delSysRole({id:row.id})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '角色已删除！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 数据权限
    menuAccess: function(index, row) {
      this.menuAccessshow = true
      this.saveroleId = row.id
      let promise = new Promise((resolve, reject) => {
        qryMenuByRole({roleId:row.id==null?'':row.id})
          .then(res => {
            if (res.code==1) {
              this.changemenu(res.data)
              // this.RoleRight = this.changeArr(res.data)
              resolve(res.data);
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      });
      let promise2 = new Promise((resolve, reject) => {
        qryMenuByRole({})
          .then(res => {
            if (res.code==1) {
              this.RoleRight = this.changeArr(res.data)
              resolve(res.data)
            } else {
              reject()
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      });
      Promise.all([promise,promise2]).then(() => {
      }).catch(err => {
      });

    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].children.length; j++) {
          change.push(arr[i].children[j].id)
        }
      }
      console.log(change);
      this.checkmenu = change
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = []
      for (var i in list) {
        if (!temptree[list[i].id]) {
          var trow = {
            id: list[i].id,
            pId: list[i].parentId,
            name: list[i].menuName,
            // open: list[i].open,
            // checked: list[i].checked,
            children: []
          }
          temptree[list[i].id] = trow
          items.push(trow)
        }
        if (list[i].children.length > 0) {
          for(var j in list[i].children){
            temptree[list[i].id]['children'].push({
              id: list[i].children[j].id,
              pId: list[i].children[j].parentId,
              name: list[i].children[j].menuName,
              // open: list[i].open,
              // checked: list[i].checked,
              children: []
            })
          }

        }
      }

      for (var j in items) {
        if (temptree[items[j].parentId]) {
          temptree[items[j].parentId]['children'].push(temptree[items[j].id])
        } else {
          tree.push(temptree[items[j].id])
        }
      }
      temptree = null
      items = null
      return tree
    },
    // 菜单权限-保存
    menuPermSave() {

      let parentArr = this.$refs.tree.getHalfCheckedKeys();
      //获取子节点未全选时的父节点id
      let childArr = this.$refs.tree.getCheckedKeys();
      //获取所有选中节点的id

      let list= parentArr.concat(childArr);
      if (list.length != 0) {
        for (let i = 0; i < list.length; i++) {
          list[i]={
            menuId:list[i],
            roleId:undefined==this.saveroleId?'1':this.saveroleId
          }
        }
      }

      let parm = {
        id:undefined==this.saveroleId?'1':this.saveroleId,
        list:list
      }
      upSysRoleMenu(parm)
        .then(res => {
          if (res.code==1) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.menuAccessshow = false
            this.tableList(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
    },
    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upSysRole(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
/deep/ .el-input__prefix,
/deep/ .el-input__icon {
  line-height: 25px;
}
/deep/ .el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 23px;
  width: 5%;
  color: #303133;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Role.vue